module.exports = __webpack_public_path__ + "static/media/3dCompound1.e8bc9919.jpg";